import { type JSX, Show } from "solid-js";

/**
 * Figma ride-sheet band (06 / E1): inset 15 px, radius 10, 22 px icon at 12 px, text 9 px after it.
 * "ok": lilac 40 px, violet Medium 14. "warn": #fcebeb 48 px (two lines), red Medium 13.
 * With `onClick` it is a button (E1 → E3 guidance).
 */
export function SheetBand(props: {
  tone: "ok" | "warn";
  children: JSX.Element;
  onClick?: () => void;
}) {
  const cls = () =>
    `-mx-[5px] flex w-[calc(100%+10px)] items-center gap-[9px] rounded-[10px] pl-3 pr-2 text-left font-medium leading-[1.25] ${
      props.tone === "ok"
        ? "min-h-[40px] bg-surface2 text-sm tracking-[0.14px] text-violet"
        : "min-h-[48px] bg-[#fcebeb] py-[6px] text-[13px] tracking-[0.13px] text-[#e53935]"
    }`;
  const icon = () => (
    <img
      src={props.tone === "ok" ? "/icons/check-circle.svg" : "/icons/warning-red.svg"}
      width="22"
      height="22"
      alt=""
      class="shrink-0"
    />
  );
  // <Show>, not a ternary: the band stays mounted while `onClick` comes and goes (E1: a parking
  // nearby appears after the band does).
  return (
    <Show
      when={props.onClick}
      fallback={
        <div class={cls()} role="status">
          {icon()}
          <span>{props.children}</span>
        </div>
      }
    >
      {(onClick) => (
        <button type="button" class={cls()} onClick={() => onClick()()}>
          {icon()}
          <span>{props.children}</span>
        </button>
      )}
    </Show>
  );
}
